// extracted by mini-css-extract-plugin
export var active = "_6g-b";
export var activeIndicator = "_6g-6";
export var animate = "_6g-a";
export var disabled = "_6g-c";
export var flat = "_6g-1";
export var fullWidth = "_6g-3";
export var lg = "_6g-9";
export var md = "_6g-8";
export var redoButtonTabGroup = "_6g-0";
export var sm = "_6g-7";
export var tabButton = "_6g-4";
export var tabButtonsContainer = "_6g-2";
export var xs = "_6g-5";